// extracted by mini-css-extract-plugin
module.exports = {"homeProject_content":"projectSkeleton_homeProject_content__3IgB_","title":"projectSkeleton_title__2NRyX","content":"projectSkeleton_content__DKBaJ"};